import { Trash2 } from 'lucide-react';
import { cn } from '@/lib/cn';

/**
 * El zafacón en un círculo rojo: borrar algo, sin la palabra «Eliminar».
 *
 * Nació el 21-sep-2026, en el primer día de prueba con el equipo de Osito. El
 * texto «Eliminar» / «Borrar» en rojo, del mismo tamaño que «Conectar» o
 * «Editar», ocupaba la fila y pedía atención como si fuera una acción más del
 * día. Borrar es lo contrario: se hace rara vez y no se deshace. El ícono solo
 * la sigue dejando a mano para quien la busca, sin ponerla a la par del resto.
 *
 * Nunca borra por sí mismo: el `onClick` de cada pantalla abre su confirmación.
 * `etiqueta` es obligatoria porque, sin texto, es lo único que un lector de
 * pantalla —y el tooltip— dicen de este botón: tiene que nombrar QUÉ se borra.
 */
export function BotonEliminar({
  etiqueta,
  onClick,
  className,
}: {
  etiqueta: string;
  onClick: () => void;
  className?: string;
}) {
  return (
    <button
      type="button"
      aria-label={etiqueta}
      title={etiqueta}
      onClick={onClick}
      className={cn(
        'inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-full',
        'bg-red-50 text-danger ring-1 ring-red-200 transition-colors',
        'hover:bg-danger hover:text-white hover:ring-danger',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-danger focus-visible:ring-offset-2',
        'dark:bg-red-900/20 dark:ring-red-900/60 dark:hover:bg-danger dark:hover:text-white',
        className,
      )}
    >
      <Trash2 className="h-4 w-4" />
    </button>
  );
}
